export const bookDimensionsEn = {
  "dimensions.title": "Cost and profit centers",
  "dimensions.description": "Assign a project, location or person center to journal and invoice rows; posted amounts remain unchanged.",
  "dimensions.code": "Center code", "dimensions.name": "Center name", "dimensions.type": "Center type",
  "dimensions.project": "Project", "dimensions.location": "Location", "dimensions.person": "Person",
  "dimensions.parent": "Parent center (optional)", "dimensions.notes": "Description and notes",
  "dimensions.new": "Add center", "dimensions.edit": "Edit center", "dimensions.save": "Save center",
  "dimensions.active": "Active", "dimensions.inactive": "Inactive",
  "dimensions.activate": "Activate", "dimensions.deactivate": "Deactivate",
  "dimensions.unassigned": "Not assigned to a center", "dimensions.none": "No center",
  "dimensions.empty": "No cost or profit centers have been added.",
  "dimensions.scope": "Select a company and project to manage centers.",
  "dimensions.noAccess": "Cost/profit centers require company write and project editor access.",
  "dimensions.loadError": "Could not load centers.",
  "dimensions.saveError": "Could not save the center. Check its code, type and parent.",
  "dimensions.report": "Profit and cost by center",
  "dimensions.reportDescription": "Posted revenue and expenses by assigned center in the selected period. Unassigned postings are shown separately; parent rows do not double-count children.",
  "dimensions.postings": "Posted entries for this center", "dimensions.reportEmpty": "No posted revenue or expenses in this period.",
  "dimensions.close": "Close details",
} as const

export const bookDimensionsEt: Record<keyof typeof bookDimensionsEn, string> = {
  "dimensions.title": "Kulu- ja kasumikeskused",
  "dimensions.description": "Määra kande- või arvereale projekti, asukoha või isiku keskus. Kinnitatud summad ei muutu.",
  "dimensions.code": "Keskuse kood", "dimensions.name": "Keskuse nimi", "dimensions.type": "Keskuse liik",
  "dimensions.project": "Projekt", "dimensions.location": "Asukoht", "dimensions.person": "Isik",
  "dimensions.parent": "Ülemkeskus (valikuline)", "dimensions.notes": "Kirjeldus ja märkused",
  "dimensions.new": "Lisa keskus", "dimensions.edit": "Muuda keskust", "dimensions.save": "Salvesta keskus",
  "dimensions.active": "Aktiivne", "dimensions.inactive": "Mitteaktiivne",
  "dimensions.activate": "Aktiveeri", "dimensions.deactivate": "Muuda mitteaktiivseks",
  "dimensions.unassigned": "Keskus määramata", "dimensions.none": "Keskuseta",
  "dimensions.empty": "Kulu- ja kasumikeskusi pole veel lisatud.",
  "dimensions.scope": "Keskuste haldamiseks vali ettevõte ja projekt.",
  "dimensions.noAccess": "Keskuste vaatamiseks on vaja ettevõtte muutmisõigust ja projekti toimetaja õigust.",
  "dimensions.loadError": "Keskusi ei saanud laadida.",
  "dimensions.saveError": "Keskust ei saanud salvestada. Kontrolli koodi, liiki ja ülemkeskust.",
  "dimensions.report": "Tulud ja kulud keskuste järgi",
  "dimensions.reportDescription": "Kinnitatud tulud ja kulud keskuste järgi valitud perioodis. Keskuseta kanded on eraldi; ülemkeskuses lapsi topelt ei arvestata.",
  "dimensions.postings": "Keskuse kinnitatud kanded", "dimensions.reportEmpty": "Selles perioodis pole kinnitatud tulusid ega kulusid.",
  "dimensions.close": "Sulge üksikasjad",
}

export const bookDimensionsRu: Record<keyof typeof bookDimensionsEn, string> = {
  "dimensions.title": "Центры затрат и прибыли",
  "dimensions.description": "Привяжите проект, место или человека к строке проводки либо счёта; суммы проведённых записей не меняются.",
  "dimensions.code": "Код центра", "dimensions.name": "Название центра", "dimensions.type": "Тип центра",
  "dimensions.project": "Проект", "dimensions.location": "Место", "dimensions.person": "Человек",
  "dimensions.parent": "Родительский центр (необязательно)", "dimensions.notes": "Описание и примечания",
  "dimensions.new": "Добавить центр", "dimensions.edit": "Изменить центр", "dimensions.save": "Сохранить центр",
  "dimensions.active": "Активен", "dimensions.inactive": "Неактивен",
  "dimensions.activate": "Активировать", "dimensions.deactivate": "Деактивировать",
  "dimensions.unassigned": "Центр не назначен", "dimensions.none": "Без центра",
  "dimensions.empty": "Центры затрат и прибыли пока не добавлены.",
  "dimensions.scope": "Выберите компанию и проект для управления центрами.",
  "dimensions.noAccess": "Для центров нужны права на изменение компании и роль редактора проекта.",
  "dimensions.loadError": "Не удалось загрузить центры.",
  "dimensions.saveError": "Не удалось сохранить центр. Проверьте код, тип и родительский центр.",
  "dimensions.report": "Прибыль и затраты по центрам",
  "dimensions.reportDescription": "Проведённые доходы и расходы по центрам за выбранный период. Записи без центра показаны отдельно; суммы дочерних центров не дублируются в родительском.",
  "dimensions.postings": "Проводки центра", "dimensions.reportEmpty": "За этот период нет проведённых доходов или расходов.",
  "dimensions.close": "Закрыть детали",
}
